import { FaStar, FaQuoteLeft, FaHome, FaCheckCircle } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './testimonials.css';
import React from "react";
import {
    Box,
    Typography,
    Avatar,
    Card,
    Rating
} from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <ArrowForwardIosIcon
            className={className}
            style={{
                ...style,
                display: "block",
                color: "#d8b035",
                fontSize: '30px',
                right: '-40px'
            }}
            onClick={onClick}
        />
    );
};

const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <ArrowBackIosIcon
            className={className}
            style={{
                ...style,
                display: "block",
                color: "#d8b035",
                fontSize: '30px',
                left: '-35px'
            }}
            onClick={onClick}
        />
    );
};

const Testimonials = () => {
    const reviews = [
        {
            name: 'Rajesh Kumar',
            location: 'UK',
            propertyType: 'Villa',
            rating: 5,
            review: 'Royale Spaces helped us find our dream villa in Amaravati. Their transparency and professionalism made the entire process smooth and stress-free.',
            avatar: 'https://ui-avatars.com/api/?name=Rajesh+Kumar&background=667eea&color=fff&size=80',
            verified: true
        },
        {
            name: 'Anjali Devi',
            location: 'Canada',
            propertyType: 'Apartment',
            rating: 5,
            review: 'Excellent service and professional team. They helped me find the perfect property in Amaravati. Highly recommended for anyone looking for real estate.',
            avatar: 'https://ui-avatars.com/api/?name=Anjali+Devi&background=10b981&color=fff&size=80',
            verified: true
        },
        {
            name: 'Suresh Babu',
            location: 'Hyderabad',
            propertyType: 'Commercial',
            rating: 5,
            review: 'Outstanding experience from start to finish. The transparency and genuine service provided by Royale Spaces made our property purchase smooth and hassle-free.',
            avatar: 'https://ui-avatars.com/api/?name=Suresh+Babu&background=f97316&color=fff&size=80',
            verified: true
        },
        {
            name: 'Lakshmi Narayana',
            location: 'Vijayawada',
            propertyType: 'Plot',
            rating: 5,
            review: 'Best real estate company in Amaravati! They guided us through every step and helped us get the best deal on our agricultural land.',
            avatar: 'https://ui-avatars.com/api/?name=Lakshmi+Narayana&background=ec4899&color=fff&size=80',
            verified: true
        },
        {
            name: 'Venkatesh Prasad',
            location: 'Guntur',
            propertyType: 'Villa',
            rating: 5,
            review: 'Highly satisfied with the service. They have a great collection of plots in Guntur and Amaravati.',
            avatar: 'https://ui-avatars.com/api/?name=Venkatesh+Prasad&background=8b5cf6&color=fff&size=80',
            verified: true
        },
        {
            name: 'Ramana Murthy',
            location: 'Vizag',
            propertyType: 'Commercial',
            rating: 5,
            review: 'Professional and trustworthy. They helped me secure a prime commercial spot in record time.',
            avatar: 'https://ui-avatars.com/api/?name=Ramana+Murthy&background=ef4444&color=fff&size=80',
            verified: true
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    nextArrow: <NextArrow />,
                    prevArrow: <PrevArrow />
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: <NextArrow />,
                    prevArrow: <PrevArrow />
                }
            }
        ]
    };

    return (
        <section className="testimonials-section">
            <div className="container">
                <div className="testimonials-header">
                    <h2 style={{ color: "rgb(51, 51, 51)" }}>What Our Clients Say</h2>
                    <p>At Royale Spaces, every review reflects our commitment to transparency, genuine service, and trusted property deals in Amaravati.</p>
                </div>

                <div className="testimonials-carousel">
                    <Slider {...settings}>
                        {reviews.map((review, index) => (
                            // <div key={index} className="testimonial-slide">
                            //     <div className="testimonial-card">
                            //         <div className="card-header-accent"></div>

                            //         <div className="quote-icon-top">
                            //             <FaQuoteLeft />
                            //         </div>

                            //         <div className="testimonial-content">
                            //             <div className="reviewer-info">
                            //                 <div className="avatar-wrapper">
                            //                     <img src={review.avatar} alt={review.name} className="reviewer-avatar" />
                            //                     {review.verified && (
                            //                         <div className="verified-badge">
                            //                             <FaCheckCircle />
                            //                         </div>
                            //                     )}
                            //                 </div>
                            //                 <div className="reviewer-details">
                            //                     <h4>{review.name}</h4>
                            //                     <div className="property-info">
                            //                         <span className="property-type">
                            //                             <FaHome /> {review.propertyType}
                            //                         </span>
                            //                         <span className="location">{review.location}</span>
                            //                     </div>
                            //                     <div className="rating">
                            //                         {[...Array(review.rating)].map((_, i) => (
                            //                             <FaStar key={i} className="star-icon" />
                            //                         ))}
                            //                     </div>
                            //                 </div>
                            //             </div>

                            //             <p className="review-text">"{review.review}"</p>
                            //         </div>
                            //     </div>
                            // </div>

                            <Box
                                sx={{
                                    width: 300,
                                    height: 330,
                                    position: "relative",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                }}
                            >
                                {/* TOP HALF */}
                                <Box
                                    sx={{
                                        height: "50%",
                                        // backgroundImage:
                                        //     "url('https://images.unsplash.com/photo-1494526585095-c41746248156')",
                                        // backgroundSize: "cover",
                                        // backgroundPosition: "center",
                                        position: "relative",
                                    }}
                                >
                                    {/* Overlay */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            backgroundColor: "rgba(223, 190, 90, 0.9)",
                                        }}
                                    />

                                    {/* Title */}
                                    <Typography
                                        sx={{
                                            position: "relative",
                                            textAlign: "center",
                                            color: "#fff",
                                            fontWeight: 600,
                                            fontSize: "20px",
                                            pt: 2,
                                            letterSpacing: "1px",
                                        }}
                                    >
                                        {review.name}
                                    </Typography>
                                </Box>

                                {/* BOTTOM HALF */}
                                <Box
                                    sx={{
                                        height: "50%",
                                        backgroundColor: "#d6b34c",
                                    }}
                                />

                                {/* CARD */}
                                <Card
                                    sx={{
                                        position: "absolute",
                                        top: "62%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "85%",
                                        borderRadius: "16px",
                                        pt: 5,
                                        pb: 1.5,
                                        px: 1.5,
                                        textAlign: "center",
                                        overflow: "visible",
                                    }}
                                >
                                    {/* Quote Left */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: 16,
                                            left: 16,
                                            width: 26,
                                            height: 26,
                                            backgroundColor: "#bdbdbd",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <FormatQuoteIcon sx={{ color: "#fff", fontSize: 16 }} />
                                    </Box>

                                    {/* Avatar */}
                                    <Avatar
                                        sx={{
                                            width: 70,
                                            height: 70,
                                            position: "absolute",
                                            top: "-35px",
                                            left: "50%",
                                            transform: "translateX(-50%)",

                                            /* Yellow default background */
                                            backgroundColor: "#d6b34c",

                                            /* Text */
                                            color: "#ffffff",
                                            fontWeight: 700,
                                            fontSize: "24px",

                                            /* Soft button-style shadow (light grey) */
                                            boxShadow: `
                                                        0 6px 12px rgba(0, 75, 173, 0.6),
                                                        0 2px 4px rgba(0, 75, 173, 0.51)

                                                        `,
                                        }}
                                    >
                                        {review.name
                                            .split(" ")
                                            .map(word => word[0])
                                            .join("")}
                                    </Avatar>


                                    {/* Content */}
                                    <Typography
                                        sx={{
                                            fontSize: "13px",
                                            color: "#444",
                                            lineHeight: 1.6,
                                            mt: 1,
                                        }}
                                    >
                                        "{review.review}"
                                    </Typography>

                                    {/* Name */}
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            mt: 1.5,
                                            fontSize: "12px",
                                        }}
                                    >
                                        {review.name}
                                    </Typography>

                                    {/* Role */}
                                    <Typography
                                        sx={{
                                            fontSize: "10px",
                                            color: "#777",
                                            mb: 0.5,
                                        }}
                                    >
                                        {review.location}
                                    </Typography>

                                    {/* Rating */}
                                    <Rating
                                        value={review.rating}
                                        readOnly
                                        size="small"
                                        sx={{ color: "#004aad" }}

                                    />

                                    {/* Quote Right */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: 16,
                                            right: 16,
                                            width: 26,
                                            height: 26,
                                            backgroundColor: "#bdbdbd",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <FormatQuoteIcon
                                            sx={{
                                                color: "#fff",
                                                fontSize: 16,
                                                transform: "rotate(180deg)",
                                            }}
                                        />
                                    </Box>
                                </Card>
                            </Box>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
